import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import Slideshow from './Slideshow';
import Moviecard from './Moviecard';
import ContinueWatch from './ContinueWatch';
import { ShimmerThumbnail, ShimmerPostList } from "react-shimmer-effects";
import styled from 'styled-components';
import { Contextone } from './Context';
import { fetchBanner, fetchSectionList } from './Api'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const LanguageData = ({ props }) => {

    const { lid } = useParams();
    const countercontext = useContext(Contextone);   
    const isurl = countercontext.isDomain;
    const typeId = countercontext.isTid;
    const apiUrl = `https://${isurl}`;
    const [sectionList, setSectionList] = useState([]);
    const [banner, setBanner] = useState([]);
    const [bannerData, setBannerData] = useState('')
    const [loading, setLoading] = useState(false);
    const [continueList, setContinueList] = useState([]);

    useEffect(() => {
        const fetchBannerData = async () => {
            try {
                const data = await fetchBanner(apiUrl, typeId, countercontext.isHomeId, lid);
                const filteredBanner = data.result.filter(item => ![3, 4, 6].includes(item.video_type));
                setBanner(filteredBanner);
            } catch (error) {
                console.error('Error:', error);
            }
        };

        const fetchData = async () => {
            try {
                const data1 = await fetchSectionList(apiUrl,countercontext.isTid, countercontext.isHomeId, lid);
                const filteredData = data1.result.filter(item => ![3, 4, 6].includes(item.video_type));
                setSectionList(filteredData);
                setContinueList(sectionList.continue_watching);
            } catch (error) {
                console.error('Error:', error);
            }
        };

        const fetchAllData = async () => {
            setLoading(true);
            await Promise.all([fetchBannerData(), fetchData()]);
            setLoading(false);
        };

        fetchAllData()

    }, [lid]);

    useEffect(() => {
        if (banner && banner.length > 0) {
            setBannerData(banner[0].id);
        } else {
            setBannerData(null); 
        }
    }, [banner]);

    let isDataAvailable = 0;

    {
        sectionList.map((mtype, index) => {
            if (mtype.data.length > 0) {
                isDataAvailable = true;
            }
        })
    }
    

    return (
        <>
            <div>
                {loading ? (
                    <div style={{ marginTop: "60px", width: "100vw", minWidth: "100vw" }}>
                        <div className="shimmer-container">
                            <ShimmerThumbnail className="shimmer-thumbnail" />
                        </div>
                        <Moviecard loading={true} />
                    </div>
                ) : (

                    isDataAvailable ? (
                        <div className="home-body">
                            {bannerData ?
                                <>
                                    <Slideshow data={banner} bannervisible={true}  isType={'language'}/>
                                    <Moviecard data={sectionList} bannervisible={true} loading={false} type={'language'}/>
                                </> :
                                <>
                                    <Moviecard data={sectionList} bannervisible={false} loading={false} type={'language'}/>
                                </>}
                        </div>
                    ) : (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh', color:'white' }}>
                            <h2>No data available</h2>
                        </div>
                    )
                )}
            </div>
        </>
    );
};

export default LanguageData;
